import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import '../../style/speakSearch.css';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothWiseCallCenterVoter = () => {
    // --- State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cardSearchTerm, setCardSearchTerm] = useState("");
    const [filterStatus, setFilterStatus] = useState('all'); // 'all', 'available', 'not_available', 'pending'


    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // --- Filter Dropdown State ---
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);

    // --- Context & Router ---
    const { appId, language, userId } = useAppId();
    const location = useLocation();
    const navigate = useNavigate();

    // Get booth_no from location state
    const boothNo = location.state?.boothNo || location.state?.booth_id || location.state?.selectedBoothNo || '';

    const lang = language || 'en';

    // Helper function to convert Status 'D', 'C', 'P', 'N' to Full Form
    const getStatusFullForm = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'D': return 'Doubtful';
            case 'C': return "Can't Say";
            case 'P': return 'Positive';
            case 'N': return 'Negative';
            default: return statusCode || 'Voted';
        }
    };

    // Get status badge color based on status code
    const getStatusBadgeColor = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'P': return 'status-positive';
            case 'N': return 'status-negative';
            case 'D': return 'status-doubtful';
            case 'C': return 'status-cant-say';
            default: return 'status-pending';
        }
    };

    const t = {
        en: {
            pageTitle: "Booth Wise Call Center Voter",
            pageSubtitle: "Voter list for call center operations.",
            filterPlaceholder: "Search by name, mobile or ID...",
            loadingData: "Loading Data...",
            noVoters: "No voters found for this booth.",
            noMatching: "No matching voters found.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            address: "Address :",
            addSurvey: "Add Survey",
            filterAll: "All",
            filterAvailable: "Available",
            filterNotAvailable: "Not Available",
            filterPending: "Pending",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"

        },
        hi: {
            pageTitle: "बूथ वाइज कॉल सेंटर मतदाता",
            pageSubtitle: "कॉल सेंटर संचालन के लिए मतदाता सूची।",
            filterPlaceholder: "नाम, मोबाइल या आईडी से खोजें...",
            loadingData: "डेटा लोड हो रहा है...",
            noVoters: "इस बूथ के लिए कोई मतदाता नहीं मिला।",
            noMatching: "कोई मेल खाने वाला मतदाता नहीं मिला।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            addSurvey: "सर्वेक्षण जोड़ें",
            filterAll: "सभी",
            filterAvailable: "उपलब्ध",
            filterNotAvailable: "अनुपलब्ध",
            filterPending: "लंबित",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            pageTitle: "બૂથ વાઇઝ કોલ સેન્ટર મતદાર",
            pageSubtitle: "કોલ સેન્ટર કામગીરી માટે મતદાર યાદી.",
            filterPlaceholder: "નામ, મોબાઇલ અથવા ID દ્વારા શોધો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noVoters: "આ બૂથ માટે કોઈ મતદાર મળ્યા નથી.",
            noMatching: "કોઈ મેળ ખાતો મતદાર મળ્યો નથી.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            address: "સરનામું :",
            addSurvey: "સર્વે ઉમેરો",
            filterAll: "બધા",
            filterAvailable: "ઉપલબ્ધ",
            filterNotAvailable: "અનુપલબ્ધ",
            filterPending: "બાકી",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"


        }
    };

    const txt = t[lang] || t.gu;
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };


    const fetchVoters = async () => {
        if (!appId || !boothNo) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_booth_wise_survey_for_call_center`,
                {
                    app_id: appId,
                    booth_no: boothNo,
                    user_id: userId
                }
            );

            if (response.data.success && Array.isArray(response.data.data.result)) {
                setVoters(response.data.data.result);
            } else {
                setVoters([]);
            }
        } catch (error) {
            console.error("Error fetching voters:", error);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!appId) {
            navigate("/");
            return;
        }
        if (!boothNo) {
            navigate(-1);
            return;
        }
        fetchVoters();
    }, [appId, boothNo, navigate]);

    useEffect(() => {
        setCurrentPage(1);
    }, [cardSearchTerm, filterStatus]);

    // Filter logic with status filter and search
    const filteredVoters = voters.filter((voter) => {
        // Search filter (name, mobile, ID)
        let matchesSearch = true;
        if (cardSearchTerm) {
            const lowerSearch = cardSearchTerm.toLowerCase();
            const fName = voter.eng_f_name ? voter.eng_f_name.toLowerCase() : "";
            const sName = voter.eng_surname ? voter.eng_surname.toLowerCase() : "";
            const fullName = `${fName} ${sName}`.trim();
            const mobile = voter.contact_no ? voter.contact_no.toString() : "";
            const idCard = voter.idcard_no ? voter.idcard_no.toLowerCase() : "";

            matchesSearch = fullName.includes(lowerSearch) ||
                mobile.includes(lowerSearch) ||
                idCard.includes(lowerSearch);
        }

        // Status filter
        let matchesStatus = true;
        if (filterStatus === 'available') {
            matchesStatus = voter.survey === 1 && voter.voter_status !== '';
        } else if (filterStatus === 'not_available') {
            matchesStatus = voter.survey_id === 0 && !voter.voter_status;
        } else if (filterStatus === 'pending') {
            matchesStatus = voter.survey === 0 && voter.voter_status !== '';
        }

        return matchesSearch && matchesStatus;
    });

    // --- Pagination Logic ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVoters = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFilterDropdownOpen && !event.target.closest('.filter-dropdown-container')) {
                setIsFilterDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isFilterDropdownOpen]);

    // Get filter button text based on current filter
    const getFilterButtonText = () => {
        switch (filterStatus) {
            case 'available': return txt.filterAvailable;
            case 'not_available': return txt.filterNotAvailable;
            case 'pending': return txt.filterPending;
            default: return txt.filterAll;
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no || voter.contact_no === '-') {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no || voter.contact_no === '-') {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className='app-container p-4 pb-5'>

            <Header title={txt.pageTitle} />

            {/* Subtitle with Booth No */}
            <div className="subtitle-container mb-3">
                <p className="subtitle-text">
                    <span>Booth No: {boothNo} • {txt.pageSubtitle}</span>
                </p>
            </div>

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Filter Row with Search and Filter Button */}
            <div className="filter-container mt-3">
                <div className="search-wrapper">
                    <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        className="search-input-modern"
                        type="text"
                        placeholder={txt.filterPlaceholder}
                        value={cardSearchTerm}
                        onChange={(e) => setCardSearchTerm(e.target.value)}
                    />
                </div>

                {/* Filter Dropdown Button */}
                <div className="filter-dropdown-container">
                    <button
                        className="filter-btn"
                        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
                    >
                        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
                        </svg>
                        {getFilterButtonText()}
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <polyline points="6 9 12 15 18 9" />
                        </svg>
                    </button>

                    {isFilterDropdownOpen && (
                        <div className="filter-dropdown-menu">
                            <button
                                className={`filter-option ${filterStatus === 'all' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('all'); setIsFilterDropdownOpen(false); }}
                            >
                                {txt.filterAll}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'available' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('available'); setIsFilterDropdownOpen(false); }}
                            >
                                <span className="filter-dot available-dot"></span>
                                {txt.filterAvailable}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'not_available' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('not_available'); setIsFilterDropdownOpen(false); }}
                            >
                                <span className="filter-dot not-available-dot"></span>
                                {txt.filterNotAvailable}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'pending' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('pending'); setIsFilterDropdownOpen(false); }}
                            >
                                <span className="filter-dot pending-dot"></span>
                                {txt.filterPending}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper text-center p-5">
                    <div className="spinner"></div>
                    <p className="mt-3">{txt.loadingData}</p>
                </div>
            ) : (
                <>
                    <div style={{ marginBottom: filteredVoters.length > itemsPerPage ? '80px' : '0' }}>
                        <div className="row g-4">
                            {currentVoters.length > 0 ? (
                                currentVoters.map((voter, index) => (
                                    <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                        <div className="voter-card-clean h-100">
                                            {/* Header with Conditional Badge/Button */}
                                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                                    <span className="voter-name-bold ms-2">{voter.eng_f_name || '-'} {voter.eng_surname || ''}</span>
                                                </div>
                                                <div>
                                                    {voter.survey_id === 0 && !voter.voter_status && (
                                                        <button
                                                            className="btn-add-survey"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate('/voter_survey_form', { state: { voter: voter } });
                                                            }}
                                                        >
                                                            + {txt.addSurvey}
                                                        </button>
                                                    )}
                                                    {voter.voter_available && voter.voter_status && (
                                                        <span
                                                            className={`badge-status ${getStatusBadgeColor(voter.voter_status)}`}
                                                        >
                                                            {getStatusFullForm(voter.voter_status)}
                                                        </span>
                                                    )}
                                                    {voter.survey_id === 0 && voter.voter_status && (
                                                        <span
                                                            className="badge-status status-pending-badge"
                                                        >
                                                            Pending
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="voter-body position-relative">
                                                <div
                                                    className="map-icon-wrapper"
                                                    style={{ cursor: 'pointer', zIndex: 10 }}
                                                    title="View on Google Maps"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const address = voter.eng_localityid;
                                                        if (address && address !== "N/A") {
                                                            // ગુગલ મેપ્સમાં એડ્રેસ સર્ચ કરવા માટેની લિંક
                                                            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                                        } else {
                                                            alert("Address not available!");
                                                        }
                                                    }}
                                                >
                                                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                                </div>
                                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span className="label">{txt.mobile}</span>
                                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                    <svg
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditingVoter(voter);
                                                            setNewMobile(voter.contact_no || '');
                                                            setIsEditMobileOpen(true);
                                                        }}
                                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                    </svg>
                                                </div>
                                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                                            </div>

                                            <div className="voter-actions">
                                                <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                            alert("Mobile number is not available for this voter.");
                                                        }
                                                        else {
                                                            window.open(`tel:${voter.contact_no}`, '_blank');
                                                        }
                                                    }}

                                                />
                                                <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                                {/* નવો કોડ */}
                                                <WhatsappSlipButton voter={voter} />
                                                {/* નોંધ: જો map માં વેરીએબલ નું નામ member હોય, તો voter={member} પાસ કરજો */}
                                                <ActionButton
                                                    icon="🖨"
                                                    color="#f97316"
                                                    label={txt.print}
                                                    onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                                />
                                                <PracharButton voter={voter} />
                                                <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-muted p-5 w-100">{voters.length === 0 ? txt.noVoters : txt.noMatching}</div>
                            )}
                        </div>

                        {/* --- PAGINATION CONTROLS --- */}
                        {!loading && filteredVoters.length > itemsPerPage && (
                            <div className="pagination-wrapper fixed-bottom-pagination">
                                <div className="pagination-content">
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                    </button>
                                    <div className="page-numbers">
                                        {getPageNumbers().map((number, index) => (
                                            <React.Fragment key={index}>
                                                {number === '...' ? (
                                                    <span className="page-dots">...</span>
                                                ) : (
                                                    <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            <style jsx>{`
                .filter-container { 
                    display: flex; 
                    flex-direction: row;
                    justify-content: space-between; 
                    align-items: center; 
                    gap: 12px;
                    margin-bottom: 24px; 
                }
                .search-wrapper { 
                    position: relative; 
                    flex: 1;
                    max-width: none; 
                }
                .search-icon-main { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    color: #94a3b8; 
                    width: 18px; 
                    height: 18px; 
                }
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 16px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 10px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                    flex-shrink: 0;
                }
                
                .filter-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    width: auto;
                }
                
                .filter-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                
                .filter-dropdown-menu {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: 8px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    min-width: 160px;
                    z-index: 100;
                    overflow: hidden;
                }
                
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px 16px;
                    border: none;
                    background: white;
                    font-size: 13px;
                    font-weight: 500;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }
                
                .filter-option:hover {
                    background: #f1f5f9;
                }
                
                .filter-option.active {
                    background: #eff6ff;
                    color: #2563eb;
                }
                
                .filter-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    display: inline-block;
                }
                
                .available-dot {
                    background-color: #22c55e;
                }
                
                .not-available-dot {
                    background-color: #ef4444;
                }
                
                .pending-dot {
                    background-color: #f59e0b;
                }

                .loader-wrapper { 
                    display: flex; 
                    flex-direction: column; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 50vh; 
                    width: 100%; 
                }
                .spinner { 
                    width: 40px; 
                    height: 40px; 
                    border: 4px solid #E5E7EB; 
                    border-top: 4px solid #2563EB; 
                    border-radius: 50%; 
                    animation: spin 1s linear infinite; 
                    margin-bottom: 12px; 
                }
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); } 
                }

                /* Subtitle Styles */
                .subtitle-container {
                    margin-top: 8px;
                    margin-bottom: 12px;
                    position: relative;
                }
                .subtitle-text {
                    font-size: 14px;
                    color: #475569;
                    margin: 0 0 8px 0;
                    font-weight: 500;
                }
                .subtitle-container::after {
                    content: "";
                    display: block;
                    width: 60px;
                    height: 3px;
                    background: linear-gradient(to right, #2563eb, #60a5fa);
                    border-radius: 3px;
                    margin-top: 4px;
                }

                /* Add Survey Button */
                .btn-add-survey {
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }

                .btn-add-survey:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }

                /* Status Badges - All status types */
                .badge-status {
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 10px;
                    font-weight: 600;
                    padding: 3px 10px;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                }

                .status-positive {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }

                .status-negative {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fecaca;
                }

                .status-doubtful {
                    background-color: #fef3c7;
                    color: #92400e;
                    border: 1px solid #fde68a;
                }

                .status-cant-say {
                    background-color: #e0e7ff;
                    color: #3730a3;
                    border: 1px solid #c7d2fe;
                }

                .status-pending-badge {
                    background-color: #f3f4f6;
                    color: #6b7280;
                    border: 1px solid #d1d5db;
                }

                /* Pagination Styles */
                .fixed-bottom-pagination { 
                    position: fixed; 
                    bottom: 0; 
                    left: 0; 
                    width: 100%; 
                    display: flex; 
                    justify-content: center; 
                    padding: 15px 0 20px 0; 
                    background: transparent; 
                    z-index: 1000;
                }
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; pointer-events: none; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 10px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); pointer-events: auto; }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; transition: all 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background: #EFF6FF; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 5px; align-items: center; }
                .page-num-btn { width: 32px; height: 32px; border-radius: 50%; border: 1px solid transparent; background: transparent; color: #475569; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn.active { background-color: #2563EB; color: white; }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                /* MOBILE FIX */
                @media (max-width: 640px) {
                    .filter-container { 
                        flex-direction: row;
                        align-items: center;
                        gap: 8px;
                    }
                    .search-wrapper { 
                        max-width: none; 
                        flex: 1;
                    }
                    .filter-btn {
                        padding: 8px 12px;
                        font-size: 12px;
                    }
                    .filter-dropdown-menu {
                        right: 0;
                        left: auto;
                        min-width: 140px;
                    }
                    
                    .btn-add-survey { 
                        font-size: 10px; 
                        padding: 3px 10px; 
                    }
                    .badge-status { 
                        font-size: 9px; 
                        padding: 2px 8px; 
                    }
                    .subtitle-text {
                        font-size: 13px;
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default BoothWiseCallCenterVoter;